import { render, staticRenderFns } from "./exclusion.vue?vue&type=template&id=e88c91ce"
import script from "./exclusion.vue?vue&type=script&lang=js"
export * from "./exclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/profile/exclusion.vue
// module id = y4Cn
// module chunks = 0